export const environment = {
  name: 'test',
  apiUrl: 'https://test.mib.motion.abb.com',
  authClientId: 'pmhDL2OLuIGvcxXJFDXfi608qXIa',
  authority: 'https://stage.polaris.iam.motion.abb.com/oauth2/token',
  authWellknownEndpointUrl: 'https://stage.api.accessmanagement.motion.abb.com/polaris/oidc/.well-known/openid-configuration',
  authRedirectUrl: 'https://test.mib.motion.abb.com/ui/callback',
  authLogoutUrl: 'https://test.mib.motion.abb.com/ui/logout',
  appInsightsConnString: 'fill after initial test deploy'
};
